import { QueryProvider, AuthProvider, AppRouterProvider } from "./providers";

export function App() {
  return (
    <QueryProvider>
      <AuthProvider>
        <AppRouterProvider />
      </AuthProvider>
    </QueryProvider>
  );
}

export default App;
